(function () {
  'use strict';

  angular
    .module('trek')
    .config(config);

  function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/login');
  }
}());
